import cx from "classnames";
import React, { CSSProperties } from "react";
import { FieldsetError } from "shared/ui/fieldset/error";
import { FieldsetContent } from "./content";
import styles from "./fieldset.module.scss";
import { FieldsetFooter } from "./footer";
import { FieldsetHeader } from "./header";
import { FieldsetSubtitle } from "./subtitle";
import { FieldsetTitle } from "./title";

export interface IFieldset {
  type?: "error";
  disabled?: boolean;

  children?: React.ReactNode;
  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const Fieldset = (props: IFieldset) => {
  return (
    <div
      className={cx(
        styles.fieldset,
        props.disabled && styles.disabled,
        props.type === "error" && styles.error,
        props.className
      )}
      style={props.style}
      id={props.htmlId}
    >
      {props.children}
    </div>
  );
};

Fieldset.Header = FieldsetHeader;
Fieldset.Content = FieldsetContent;
Fieldset.Footer = FieldsetFooter;
Fieldset.Title = FieldsetTitle;
Fieldset.Subtitle = FieldsetSubtitle;
Fieldset.Error = FieldsetError;

Fieldset.defaultProps = {};
